(function() {
 
  const validPages = ['/cart', '/checkout'];
  if (!validPages.includes(window.location.pathname)) {
    return;
  }

  function loadModalScript() {
    // Helper function for size extraction
    function getVariantSize(variantTitle) {
      return variantTitle.replace(/\s*(lid|base)\s*/i, '').trim().toLowerCase();
    }

    // Modal HTML template
    const modalHTML = `
      <div id="productPairModal" class="pair-modal" style="display: none;">
        <div class="pair-modal-content">
          <h2 id="modalTitle" style="margin: 0 0 20px; font-size: 20px; color: #333;"></h2>
          <p id="modalDescription" style="margin: 0 0 20px; color: #666;"></p>
          <div id="productsList" style="margin-bottom: 20px; max-height: 400px; overflow-y: auto;">
          </div>
          <div class="pair-modal-buttons">
            <button id="viewAllBtn" class="pair-btn pair-btn-secondary">
              View All Products
            </button>
            <button id="continueBtn" class="pair-btn pair-btn-primary">
              Continue to Checkout
            </button>
          </div>
        </div>
      </div>
    `;

    // Styles
    const styles = `
      <style>
        .pair-modal {
          display: none;
          position: fixed;
          z-index: 1000;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0,0,0,0.5);
          animation: fadeIn 0.3s ease-out;
        }
        
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        
        .pair-modal-content {
          background-color: #fff;
          margin: 15vh auto;
          padding: 30px;
          border-radius: 8px;
          width: 90%;
          max-width: 600px;
          box-shadow: 0 4px 6px rgba(0,0,0,0.1);
        }
        
        .product-section {
          border: 1px solid #e5e7eb;
          border-radius: 8px;
          padding: 15px;
          margin-bottom: 20px;
          background: #f8fafc;
        }
        
        .product-header {
          display: flex;
          align-items: center;
          padding: 10px;
          border-bottom: 1px solid #e5e7eb;
          background: white;
          border-radius: 6px;
        }
        
        .product-image {
          width: 60px;
          height: 60px;
          object-fit: cover;
          margin-right: 15px;
          border-radius: 4px;
        }
        
        .product-details {
          flex-grow: 1;
        }
        
        .product-title {
          font-weight: 500;
          margin-bottom: 5px;
        }
        
        .product-variant {
          font-size: 0.9em;
          color: #666;
        }
        
        .product-quantity {
          color: #888;
          font-size: 0.9em;
        }

        .suggestion-section {
          margin-top: 15px;
          padding: 15px;
          background: white;
          border-radius: 6px;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        }

        .suggestion-header {
          font-weight: 500;
          color: #16479d;
          margin-bottom: 12px;
          padding-bottom: 8px;
          border-bottom: 1px dashed #e5e7eb;
        }

        .suggested-product {
          display: flex;
          align-items: center;
          padding: 10px;
          border: 1px solid #e5e7eb;
          border-radius: 6px;
          transition: transform 0.2s;
          margin-bottom: 10px;
        }

        .suggested-product:hover {
          transform: translateY(-2px);
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        }

        .suggestion-details {
          flex-grow: 1;
          margin-right: 15px;
        }

        .suggestion-title {
          font-weight: 500;
          margin-bottom: 4px;
        }

        .suggestion-variant {
          font-size: 0.9em;
          color: #666;
        }

        .suggestion-price {
          color: #16479d;
          font-weight: 500;
          margin-top: 4px;
        }

        .remove-btn {
          background-color: #e60000;
          color: white;
          padding: 5px 8px;
          border-radius: 4px;
          border: none;
          cursor: pointer;
          font-size: 0.9em;
          white-space: nowrap;
        }

        .remove-btn:hover {
          background-color: #cb2c2c;
        }

        .pair-modal-buttons {
          display: flex;
          justify-content: flex-end;
          gap: 10px;
          margin-top: 20px;
        }

        .pair-btn {
          padding: 12px 24px;
          border-radius: 4px;
          border: none;
          cursor: pointer;
          font-weight: 500;
          transition: background-color 0.2s;
        }

        .pair-btn-primary {
          background-color: #16479d;
          color: white;
        }

        .pair-btn-primary:hover {
          background-color: #245aa8;
        }

        .pair-btn-secondary {
          background-color: #f3f4f6;
          color: #374151;
        }

        .pair-btn-secondary:hover {
          background-color: #e5e7eb;
        }

        .add-to-cart-btn {
          background-color: #16a34a;
          color: white;
          padding: 8px 16px;
          border-radius: 4px;
          border: none;
          cursor: pointer;
          font-size: 0.9em;
          white-space: nowrap;
        }

        .add-to-cart-btn:hover {
          background-color: #15803d;
        }

        .loading {
          text-align: center;
          padding: 20px;
          color: #666;
        }

        .unpaired-section {
          margin-bottom: 30px;
        }
        
        .section-title {
          font-size: 18px;
          font-weight: 500;
          color: #16479d;
          margin: 0 0 15px;
          padding-bottom: 8px;
          border-bottom: 2px solid #e5e7eb;
        }

        .suggestion-section {
          background: #f8fafc;
          border-radius: 8px;
          margin-top: 15px;
        }

        .quantity-selector {
          display: flex;
          align-items: center;
          margin-top: 8px;
          gap: 8px;
        }

        .quantity-btn {
          background: #f3f4f6;
          border: 1px solid #e5e7eb;
          border-radius: 4px;
          width: 28px;
          height: 28px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          font-size: 16px;
          user-select: none;
        }

        .quantity-btn:hover {
          background: #e5e7eb;
        }

        .quantity-btn:disabled {
          cursor: not-allowed;
          opacity: 0.5;
        }

        .quantity-input {
          width: 40px;
          height: 28px;
          text-align: center;
          border: 1px solid #e5e7eb;
          border-radius: 4px;
          font-size: 14px;
        }

        .quantity-input::-webkit-inner-spin-button,
        .quantity-input::-webkit-outer-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }

        .quantity-input {
          -moz-appearance: textfield;
        }

        .suggestion-actions {
          display: flex;
          flex-direction: column;
          gap: 8px;
          min-width: 120px;
        }

      
      </style>
    `;

    // Insert modal and styles into the page
    document.body.insertAdjacentHTML('beforeend', modalHTML);
    document.head.insertAdjacentHTML('beforeend', styles);

    // Initialize variables and get DOM elements
    let isModalOpen = false;
    let isProcessingCheckout = false;
    let lastCheckoutTrigger = null;
    const modal = document.getElementById('productPairModal');
    const modalTitle = document.getElementById('modalTitle');
    const modalDescription = document.getElementById('modalDescription');
    const productsList = document.getElementById('productsList');
    const viewAllBtn = document.getElementById('viewAllBtn');
    const continueBtn = document.getElementById('continueBtn');

    function getCheckoutForm(triggerElement) {
      if (!triggerElement) return null;

      if (triggerElement instanceof HTMLButtonElement || triggerElement instanceof HTMLInputElement) {
        if (triggerElement.form) return triggerElement.form;

        const formId = triggerElement.getAttribute('form');
        if (formId) {
          const referencedForm = document.getElementById(formId);
          if (referencedForm instanceof HTMLFormElement) return referencedForm;
        }
      }

      const closestForm = triggerElement.closest('form');
      return closestForm instanceof HTMLFormElement ? closestForm : null;
    }

    function submitCheckout(triggerElement) {
      const checkoutForm = getCheckoutForm(triggerElement);

      if (checkoutForm) {
        let checkoutInput = checkoutForm.querySelector('input[name="checkout"]');

        if (!checkoutInput) {
          checkoutInput = document.createElement('input');
          checkoutInput.type = 'hidden';
          checkoutInput.name = 'checkout';
          checkoutInput.value = '1';
          checkoutForm.appendChild(checkoutInput);
        }

        HTMLFormElement.prototype.submit.call(checkoutForm);
        return true;
      }

      const fallbackForm = document.createElement('form');
      fallbackForm.method = 'post';
      fallbackForm.action = '/cart';
      fallbackForm.style.display = 'none';

      const checkoutField = document.createElement('input');
      checkoutField.type = 'hidden';
      checkoutField.name = 'checkout';
      checkoutField.value = '1';

      fallbackForm.appendChild(checkoutField);
      document.body.appendChild(fallbackForm);
      HTMLFormElement.prototype.submit.call(fallbackForm);
      return true;
    }

    // Main checkout handler function
    async function handleCheckoutClick(event) {
       lastCheckoutTrigger = event ? event.currentTarget || event.target : lastCheckoutTrigger;
       if (isProcessingCheckout) {
    console.log('Already processing checkout, preventing duplicate');
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    return false;
  }

  console.log('Starting checkout process');
  isProcessingCheckout = true;

  if (event) {
    event.preventDefault();
    event.stopPropagation();
    console.log('Prevented default checkout behavior');
  }
  
  try {
    console.log('Fetching cart data');
    const response = await fetch('/cart.js');
    const cart = await response.json();
    console.log('Cart data:', cart);
    
    // Filter items excluding "Base + Lid" variant titles
    const lidItems = cart.items.filter(item => 
      (item.variant_title?.toLowerCase().includes('lid') ||
      item.product_title.toLowerCase().includes('lid')) &&
      !item.variant_title.toLowerCase().includes('base + lid')
    );

    const baseItems = cart.items.filter(item => 
      (item.variant_title?.toLowerCase().includes('base') ||
      item.product_title.toLowerCase().includes('base')) &&
      !item.variant_title.toLowerCase().includes('base + lid')
    );

    // Use enhanced validation logic
    const unpairedLids = lidItems.filter(lidItem => {
      const lidSize = getVariantSize(lidItem.variant_title || lidItem.title);
      return !baseItems.some(baseItem => {
        const baseSize = getVariantSize(baseItem.variant_title || baseItem.title);
        return baseSize === lidSize;
      });
    });

    const unpairedBases = baseItems.filter(baseItem => {
      const baseSize = getVariantSize(baseItem.variant_title || baseItem.title);
      return !lidItems.some(lidItem => {
        const lidSize = getVariantSize(lidItem.variant_title || lidItem.title);
        return lidSize === baseSize;
      });
    });

    if (unpairedLids.length > 0 || unpairedBases.length > 0) {
      console.log('Found unpaired items, showing modal');
      
      modalTitle.textContent = 'Unpaired Items in Cart';
      modalDescription.textContent = 'We noticed you have some products without their matching pairs. Please review the suggestions below:';
      productsList.innerHTML = '<div class="loading">Finding matching products...</div>';
      
      modal.style.display = 'block';
      document.body.style.overflow = 'hidden';
      isModalOpen = true;

      let html = '';
      
      // Process unpaired lids
      if (unpairedLids.length > 0) {
        html += '<div class="unpaired-section"><h3 class="section-title">Unpaired Lids</h3>';
        for (const item of unpairedLids) {
          console.log('Processing lid item:', item);
          const matchingVariants = await findMatchingVariants(
            item.handle || item.product_title.toLowerCase().replace(/\s+/g, '-'),
            item.variant_title || item.title,
            'lid'
          );

          if (matchingVariants && matchingVariants.length > 0) {
            html += generateProductHTML(item, matchingVariants, 'lid');
          }
        }
        html += '</div>';
      }

      // Process unpaired bases
      if (unpairedBases.length > 0) {
        html += '<div class="unpaired-section"><h3 class="section-title">Unpaired Bases</h3>';
        for (const item of unpairedBases) {
          console.log('Processing base item:', item);
          const matchingVariants = await findMatchingVariants(
            item.handle || item.product_title.toLowerCase().replace(/\s+/g, '-'),
            item.variant_title || item.title,
            'base'
          );

          if (matchingVariants && matchingVariants.length > 0) {
            html += generateProductHTML(item, matchingVariants, 'base');
          }
        }
        html += '</div>';
      }
      
      productsList.innerHTML = html;
      isProcessingCheckout = false;
      console.log('Modal displayed with products');
      return false;
    } else {
      console.log('No unpaired items, proceeding to checkout');
      submitCheckout(lastCheckoutTrigger);
    }
  } catch (error) {
    console.error('Error during checkout process:', error);
    isProcessingCheckout = false;
    submitCheckout(lastCheckoutTrigger);
  }
  
  isProcessingCheckout = false;
  return false;
    }

    // Enhanced event listener setup
  function setupCheckoutListeners() {
    console.log('Setting up checkout listeners');
    const checkoutSelectors = '[name="checkout"], .checkout-button, #cart-checkout, [href="/checkout"]';
    
    // Remove existing listeners
    document.querySelectorAll(checkoutSelectors).forEach(button => {
      button.removeEventListener('click', handleCheckoutClick);
      
      // Add new listener with capture
      button.addEventListener('click', function(e) {
        console.log('Checkout button clicked');
        if (isModalOpen) {
          console.log('Modal is open, preventing checkout');
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
        return handleCheckoutClick(e);
      }, { capture: true });

      // Prevent default form submission if button is in a form
      const form = button.closest('form');
      if (form) {
        console.log('Found checkout form, adding submit prevention');
        form.addEventListener('submit', function(e) {
          if (isModalOpen || isProcessingCheckout) {
            console.log('Preventing form submission');
            e.preventDefault();
            e.stopPropagation();
            return false;
          }
        }, { capture: true });
      }
    });
  }

  // Initial setup
  setupCheckoutListeners();

  // Enhanced mutation observer
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(mutation => {
      if (mutation.addedNodes.length) {
        console.log('DOM changed, updating checkout listeners');
        setupCheckoutListeners();
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Enhanced modal close functionality
  function closeModal() {
    console.log('Closing modal');
    isModalOpen = false;
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }

  // Update the click event listener for the modal
  modal.addEventListener('click', function(event) {
    // Check if the click is outside the modal content
    if (event.target === modal) {
      console.log('Click detected outside modal content');
      closeModal();
    }
  });

  // Add ESC key listener for better UX
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' && isModalOpen) {
      console.log('ESC key pressed, closing modal');
      closeModal();
    }
  });

  // Prevent propagation from modal content
  document.querySelector('.pair-modal-content').addEventListener('click', function(event) {
    event.stopPropagation();
  });

  // Update modal content click handlers
  viewAllBtn.addEventListener('click', function(event) {
    event.preventDefault();
    event.stopPropagation();
    closeModal();
    window.location.href = '/collections/all';
  });
  
  continueBtn.addEventListener('click', function(event) {
    event.preventDefault();
    event.stopPropagation();
    closeModal();
    submitCheckout(lastCheckoutTrigger);
  });

  viewAllBtn.addEventListener('click', function(event) {
    event.preventDefault();
    closeModal();
    window.location.href = '/collections/all';
  });
  
  continueBtn.addEventListener('click', function(event) {
    event.preventDefault();
    closeModal();
    submitCheckout(lastCheckoutTrigger);
  });

  productsList.addEventListener('click', function(event) {
    const removeBtn = event.target.closest('.remove-btn');
    if (removeBtn) {
      const variantId = removeBtn.getAttribute('data-variant-id');
      removeFromCart(variantId);
    }
  });


  async function findMatchingVariants(productHandle, variantTitle, type) {
    try {
      const response = await fetch(`/products/${productHandle}.js`);
      const product = await response.json();
      const size = variantTitle.replace(/\s*(lid|base)\s*/i, '').trim();
      const searchTerm = type === 'lid' ? 'base' : 'lid';
      
      return product.variants.filter(variant => 
        variant.title.toLowerCase().includes(searchTerm) &&
        variant.title.toLowerCase().includes(size.toLowerCase())
      ).map(variant => ({
        id: variant.id,
        title: product.title,
        variantTitle: variant.title,
        price: `AED ${(variant.price / 100).toFixed(2)}`,
        image: variant.featured_image?.src || product.featured_image,
        available: variant.available
      }));
    } catch (error) {
      console.error(`Error finding ${type} variants:`, error);
      return null;
    }
  }

  async function addToCart(variantId, quantity = 1) {
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity }] })
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        
        // Update button state
        const btn = document.querySelector(`button[data-variant-id="${variantId}"]`);
        if (btn) {
          const originalText = btn.textContent;
          btn.textContent = 'Added!';
          btn.disabled = true;
          setTimeout(() => {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 2000);
        }

        if (typeof window.refreshCart === 'function') {
          window.refreshCart();
        }

        return result;
      } catch (error) {
        console.error('Error adding to cart:', error);
        alert('Error adding product to cart. Please try again.');
        throw error;
      }
    }

     // Add new function to handle quantity selection and add to cart
    function addToCartWithQuantity(variantId, button) {
      const quantitySelector = button.closest('.suggestion-actions').querySelector('.quantity-input');
      const quantity = parseInt(quantitySelector.value, 10);
      if (quantity > 0) {
        addToCart(variantId, quantity);
      }
    }

    // Add quantity selector event listeners
    document.addEventListener('click', function(event) {
      if (event.target.classList.contains('quantity-btn')) {
        const input = event.target.closest('.quantity-selector').querySelector('.quantity-input');
        const currentValue = parseInt(input.value, 10);
        
        if (event.target.classList.contains('decrease')) {
          if (currentValue > 1) {
            input.value = currentValue - 1;
          }
        } else if (event.target.classList.contains('increase')) {
          if (currentValue < 99) {
            input.value = currentValue + 1;
          }
        }
      }
    });

    // Insert modal and styles into the page
    document.body.insertAdjacentHTML('beforeend', modalHTML);
    document.head.insertAdjacentHTML('beforeend', styles);

    // Make functions available globally
    window.addToCartWithQuantity = addToCartWithQuantity;
    window.addToCart = addToCart;

    
    // Add input validation for quantity
    document.addEventListener('input', function(event) {
      if (event.target.classList.contains('quantity-input')) {
        let value = parseInt(event.target.value, 10);
        if (isNaN(value) || value < 1) {
          value = 1;
        } else if (value > 99) {
          value = 99;
        }
        event.target.value = value;
      }
    });

    
    
  async function removeFromCart(variantId) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 0 })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      await response.json();
      
      // Refresh the checkout validation
      await handleCheckoutClick();

      // Refresh cart if the function exists
      if (typeof window.refreshCart === 'function') {
        window.refreshCart();
      }
    } catch (error) {
      console.error('Error removing item from cart:', error);
      alert('Could not remove item. Please try again.');
      throw error;
    }
  }

  
  function generateProductHTML(item, matchingVariants, type) {
      return `
        <div class="product-section">
          <div class="product-header">
            <img src="${item.image}" alt="${item.title}" class="product-image">
            <div class="product-details">
              <div class="product-title">${item.product_title}</div>
              ${item.variant_title ? `<div class="product-variant">${item.variant_title}</div>` : ''}
              <div class="product-quantity">Quantity: ${item.quantity}</div>
              <button class="remove-btn" data-variant-id="${item.variant_id}">
                Remove ${type === 'lid' ? 'Lid' : 'Base'}
              </button>
            </div>
          </div>
          
          <div class="suggestion-section">
            <div class="suggestion-header">
              Matching ${type === 'lid' ? 'Base' : 'Lid'} Products:
            </div>
            ${matchingVariants.map(variant => `
              <div class="suggested-product">
                <img src="${variant.image}" alt="${variant.title}" class="product-image">
                <div class="suggestion-details">
                  <div class="suggestion-title">${variant.title}</div>
                  <div class="suggestion-variant">${variant.variantTitle}</div>
                  <div class="suggestion-price">${variant.price}</div>
                </div>
                <div class="suggestion-actions">
                  ${variant.available ? `
                    <div class="quantity-selector" data-variant-id="${variant.id}">
                    
                      <input type="number" class="quantity-input" value="1" min="1" max="${item.quantity}">
                      
                    </div>
                    <button 
                      class="add-to-cart-btn"
                      data-variant-id="${variant.id}"
                      onclick="window.addToCartWithQuantity('${variant.id}', this)"
                    >
                      Add to Cart
                    </button>
                  ` : `
                    <button class="add-to-cart-btn" style="background-color: #9ca3af;" disabled>
                      Sold Out
                    </button>
                  `}
                </div>
              </div>
            `).join('')}
          </div>
        </div>
      `;
    }

  window.addToCart = addToCart;
  }

  // Load the script when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadModalScript);
  } else {
    loadModalScript();
  }
})();